package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{SessionSearchData, SessionView, SessionViewResult, SubjectSessionsRequestData, TestSessionProperties, UpdateSessionsData, IdentityData}
import com.neurobs.ccabserver.administrator.view.SubjectSelectionView
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.AdminPanelController
import com.neurobs.js.dom.{ElementFactory, InputCheckBox}
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.view.{Container, Form, Gui}
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom._
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.Grid._
import com.neurobs.js.util.StringUtilities.dateString
import com.neurobs.util.JsonPrinter
import scalatags.JsDom.all._
import io.circe.generic.auto._
import org.scalajs.dom.raw.{Event, HTMLElement}

import scala.concurrent.ExecutionContext.Implicits.global
import scala.collection.mutable.ArrayBuffer

class SessionSearchController(search: SessionSearchData, title: String, gui: Gui, userData: IdentityData, addPanel: AdminPanelController => Unit)(implicit server: com.neurobs.ccab.CCABServer) extends AdminPanelController {
	//private val getSynced: InputCheckBox = ElementFactory.makeCheckbox(checked = false)
	//getSynced.setChangeHandler(() => if (getSynced.checked) update())
	private val getIdentity: InputCheckBox = ElementFactory.makeCheckbox(checked = false)
	//getIdentity.setChangeHandler(() => if (getIdentity.checked) update())
	private val mainDiv = div().render


	private val panel: PanelView = {
		val temp = new PanelView(title = title, showRefresh = true, fullWidth = true)
		val closeButton = ElementFactory.makeLink(text = "Close")
		closeButton.onclick = (_:Event) => delegate.foreach(_.close())
		temp.setRightCorner(closeButton)
		temp.refresh.setHandler(update)
		temp.grid.addRow(mainDiv)
		temp
	}

	private def handleError(message: String): Unit = {
		mainDiv.innerHTML = ""
		mainDiv.appendChild(message)
	}

	private def update(): Unit = {
		CCABServer.getTestSessionViews(search.copy(getSyncedStatus = false/*getSynced.checked*/, getIdentityData = getIdentity.checked))(CCABServer.handleObjectResult {
			case Left(error) => handleError(error)
			case Right(data) =>
				mainDiv.clear()
				mainDiv.appendChild(p(/*getSynced.input, " Get (at least partial) synced status", " ", */getIdentity.input, " Get identity data").render)
				val accounts = data.sessions.groupBy(_.session.accountId)
				for ((_, accountData) <- accounts) {
					val account = accountData.head.session
					mainDiv.appendChild(p(b("Account: "), s"${account.organization} (${account.primaryEmail} (${account.accountId}))").render)
					val studies = accountData.groupBy(_.session.studyId)
					for ((_, studyData) <- studies) {
						val study = studyData.head.session
						val subjects = studyData.groupBy(_.session.accountSubjectId)
						val chronSubjects = subjects.toVector.map(s => (s._2.map(_.session.startTime.instant.getEpochSecond).min, s._2)).sortBy(_._1).map(_._2)
						val table = ElementFactory.makeTable(List("Reporting ID", "Name/ID", "Station", "Day", "Sequence", "Synced", "Edit", "Edit All", ""))
						for (subject <- chronSubjects) {
							val sorted = subject.sortWith(_.session.startTime.instant.getEpochSecond < _.session.startTime.instant.getEpochSecond)
							import SessionSearchController._
							val head = subject.head
							val name = head.identity map { i =>
								i.firstName match {
									case Some(fn) => fn + i.lastName.fold("")(" " + _) + i.localID.fold("")(id => s" ($id)")
									case None => i.localID match {
										case None => head.session.reportingId.noBracketsString
										case Some(id) => id
									}
								}
							}
							val combined = combine(sorted)
							var first = true
							for (c <- combined) {
								val reportingId: HTMLElement = if (first) {
									c.start.reportingId.noBracketsString + s" (${c.start.accountSubjectId})"
									val link = ElementFactory.makeLink(c.start.reportingId.noBracketsString)
									link.onclick = (_: Event) => {
										server.getExaminerTags()._2 map {
											case Right(tags) =>
												delegate.foreach(_.newPanel(new SubjectSessionController2(gui, SubjectSessionsRequestData(accountId = c.start.accountId, accountSubjectId = c.start.accountSubjectId, dataPassword = search.dataPassword), userData, None, None, name.getOrElse(c.start.reportingId.noBracketsString), addPanel, tags = new ExaminerTagList(tags))))
											case Left(_) =>
										}
//										delegate.foreach(_.newPanel(new SubjectSessionController(SubjectSessionsRequestData(accountId = c.start.accountId, accountSubjectId = c.start.accountSubjectId, dataPassword = search.dataPassword), name.getOrElse(c.start.reportingId.noBracketsString))))
									}
									link
								}
								else span().render

								val changeSubjectCol: HTMLElement = search.dataPassword match {
									case None => span().render
									case Some(dataPassword) => {
										val link = ElementFactory.makeLink(text = "subject")
										link.onclick = (_: Event) => changeSubject(UpdateSessionsData(studyId = c.start.studyId, accountSubjectId = c.start.accountSubjectId, sessionIds = c.all.map(_.session.sessionId)), c.start.accountId, dataPassword)
										link
									}
								}

								val changeAllSubjectCol: HTMLElement = if (first) {
									search.dataPassword match {
										case None => span().render
										case Some(dataPassword) =>
											val link = ElementFactory.makeLink(text = "subject")
											link.onclick = (_: Event) => changeSubject(UpdateSessionsData(studyId = c.start.studyId, accountSubjectId = c.start.accountSubjectId, sessionIds = combined.flatMap(_.all.map(_.session.sessionId))), c.start.accountId, dataPassword)
											link
									}
								}
								else span().render

								val changeAllStudyCol: HTMLElement = if (first) {
									val link = ElementFactory.makeLink(text = "study")
									link.onclick = (_: Event) => changeStudy(UpdateSessionsData(studyId = c.start.studyId, accountSubjectId = c.start.accountSubjectId, sessionIds = combined.flatMap(_.all.map(_.session.sessionId))), c.start.accountId)
									link
								}
								else span().render

								val changeStudyCol: HTMLElement = {
									val link = ElementFactory.makeLink(text = "study")
									link.onclick = (_: Event) => changeStudy(UpdateSessionsData(studyId = c.start.studyId, accountSubjectId = c.start.accountSubjectId, sessionIds = c.all.map(_.session.sessionId)), c.start.accountId)
									link
								}

//								val transcriptStatusCol: HTMLElement =  {
//									val link = ElementFactory.makeLink(text = "tstatus")
//									link.onclick = (_: Event) => addPanel(new SessionTranscriptStatusController(Left(c.start.sessionId), gui))
//									link
//								}

								val idValue = if (first) name.getOrElse("") else ""
								table.addChild(ElementFactory.makeTableRow(List(reportingId, idValue, c.start.stationName, dateString(c.start.startTime), sequence(c.start), synced(c.all.toVector), span(changeStudyCol, " ", changeSubjectCol).render, span(changeAllStudyCol, " ", changeAllSubjectCol).render)))
								first = false
							}
						}
						mainDiv.appendChild(p(b("Study: "), s"${study.studyDisplayName} (${study.studyId}), ${subjects.size} subjects").render)
						val tableDiv = div().render
						tableDiv.style = "max-height: 450px; overflow-y: auto; width: fit-content"
						tableDiv.appendChild(table)
						mainDiv.appendChild(tableDiv)

					}
				}
		})
		mainDiv.innerHTML = "Retrieving Data..."
	}

	private def changeSubject(data: UpdateSessionsData, accountId: Long, dataPassword: String): Unit = {
		def showError(error: String): Unit = gui.showModalMessage(width = 30, title = "Server Error", description = error, dismissButtonCaption = "Continue")()
		SubjectSelectionView.selectSubject(accountId = accountId, dataPassword = dataPassword, gui = gui).map(_ foreach { s =>
			CCABServer.updateSessions(data.copy(accountSubjectId = s.id)) {
				case Left(err) => showError(err.message)
				case Right(res) => res.error match {
					case Some(err) => showError(err)
					case None => update()
				}
			}
		})
	}

	private def changeStudy(data: UpdateSessionsData, accountId: Long): Unit = {
		CCABServer.getStudies(accountId) {
			case Left(error) => gui.showModalMessage(width = 30, title = "Server Error", description = error.message, dismissButtonCaption = "Continue")()
			case Right(studies) =>
				val studySelect: SelectSelectBox = ElementFactory.makeSelectBox(width = 20)
				studySelect.setOptions(studies.map(_.displayName), Some(studies.indexWhere(_.id == data.studyId)))
				val form = makeForm(
					width = 30,
					title = "Change Study",
					description = "",
					elements = Array(("Study:", studySelect.select)),
					useCancel = true,
					submitCaption = "Change"
				)
				def process(callback: (Option[String]) => Unit): Either[String, Form.Process] = {
					studySelect.selectedIndex.map(studies(_).id) match {
						case None => Left("Please select a study.")
						case Some(studyId) =>
							Right(CCABServer.updateSessions(data.copy(studyId = studyId)) {
								case Left(err) => callback(Some(err.message))
								case Right(res) => res.error match {
									case Some(err) => callback(Some(err))
									case None =>
										callback(None)
										update()
								}
							})
					}
				}
				gui.showModalForm(form, process, processCancellable = true, Some(() => Unit))
		}
	}

	override def container: Container = panel.container

	update()
}

object SessionSearchController {
	case class CombinedSessionView
	(
		start: SessionView,
		all: ArrayBuffer[SessionViewResult]
	)

	def combine(subject: Seq[SessionViewResult]): Vector[CombinedSessionView] = {
		val buf = ArrayBuffer[CombinedSessionView]()
		var last: Option[CombinedSessionView] = None
		def addNew(s: SessionViewResult): Unit = {
			buf.append(CombinedSessionView(s.session, ArrayBuffer(s)))
			last = Some(buf.last)
		}
		for (v <- subject) {
			last match {
				case None => addNew(v)
				case Some(l) =>
					if ((l.start.properties == v.session.properties) && (l.start.stationName == v.session.stationName) && v.session.startTime.instant.isBefore(l.start.startTime.instant.plusSeconds(60*60*3))) l.all.append(v)
					else addNew(v)
			}
		}
		buf.toVector
	}

	def synced(r: Vector[SessionViewResult]): String = {
		val values = r.map(_.synced).distinct
		if (values.length == 0) "Unknown"
		else if (values.length > 1) "Partial"
		else values.head match {
			case None => ""
			case Some(s) => if (s) "Yes" else "No"
		}
	}

	def sequence(s: SessionView): String = s.properties.flatMap(p => JsonPrinter.fromJson[TestSessionProperties](p)).map(p => s"${p.group}/${p.sequence}").getOrElse("Unknown")
}